import {Component, Inject, OnInit} from '@angular/core';
import {ProfileModel} from '../../../models/profile.model';
import {MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'kt-accomodation-card',
  templateUrl: './accomodation-card.popup.html',
  styleUrls: ['./accomodation-card.popup.scss']
})
export class AccomodationCardPopup implements OnInit {

  profile: ProfileModel;
  hotelID: string;
  time = new Date().getTime();

  constructor(@Inject(MAT_DIALOG_DATA) public data: ProfileModel) {
  }

  ngOnInit() {
    this.profile = this.data;
    this.hotelID = JSON.parse(localStorage.getItem('token_form')).app_hotel_id;
  }

  print() {
    const printContent = document.getElementById('component1');
    const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    WindowPrt.document.write(printContent.innerHTML);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    WindowPrt.close();
  }

}
